import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { Toaster } from 'sonner'
import { ApiError } from '@/api/client'
import { AuthProvider } from '@/lib/auth'
import { I18nProvider } from '@/lib/i18n'
import { ThemeProvider, useTheme } from '@/lib/theme'
import { router } from './router'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, refetchOnWindowFocus: true, retry: (n, e) => !(e instanceof ApiError && [401, 403, 404, 422].includes(e.status)) && n < 2 },
    mutations: { retry: false },
  },
})

function ThemedToaster() {
  const { dark } = useTheme()
  return <Toaster position="top-center" richColors closeButton theme={dark ? 'dark' : 'light'} />
}

async function start() {
  // npm run dev:mock: a built-in mock of the API (never in production builds).
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK === 'true') {
    const { startMocks } = await import('./mocks/browser')
    await startMocks()
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <I18nProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <RouterProvider router={router} />
              <ThemedToaster />
            </AuthProvider>
          </QueryClientProvider>
        </I18nProvider>
      </ThemeProvider>
    </StrictMode>,
  )
}

start()
